class CartDrawer extends HTMLElement {
  constructor() {
    super();

    // TODO: Explain why this if block is needed
    if (window.innerWidth >= 990) {
      console.log('fired')
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      document.addEventListener('scroll', this.offsetDrawerHeight.bind(this))
      this.offsetDrawerHeight()
    }
    this.setHeaderCartIconAccessibility();
  }

  offsetDrawerHeight() {
    const footer = document.querySelector('.footer');
    const footerPixelsVisible = Math.round(-(footer.getBoundingClientRect().top - this.offsetHeight));

    if (footerPixelsVisible > 0) {
      Promise.resolve().then(() => {
        this.style.paddingBottom = `${footerPixelsVisible}px`
      })
    }

  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => { this.classList.add('animate', 'active') });

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    // FIX IS-37
    if (window.innerWidth < 990)
      document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);

    // FIX IS-37
    if (window.innerWidth < 990)
      document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();

      document.dispatchEvent(
        new CustomEvent("Cart-Change", {
          bubbles: true,
          detail: { info: "added" },
        }))
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

if (customElements.get('cart-items')) {
  class CartDrawerItems extends CartItems {
    getSectionsToRender() {
      return [
        {
          id: 'CartDrawer',
          section: 'cart-drawer',
          selector: '.drawer__inner'
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section'
        }
      ];
    }

    /**
     * Documentation
     * @param {Array} variants List of variant ids
     *
     */
    swapVariants(variants) {

      //this.enableLoading(line);

      const payload = {
        items: []
      }

      payload.items = variants.map(variant => {
        return {
          "id": variant.id,
          "quantity": Number(variant.quantity)
        }
      })

      const sections = {
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      }

      var requestOptions = {
        body: JSON.stringify(Object.assign(payload, sections))
      };

      fetch(`${routes.cart_clear_url}`, fetchConfig())
        .then(() => {
          fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...requestOptions })
            .then((response) => {
              return response.text();
            })
            .then((state) => {
              const parsedState = JSON.parse(state);
              this.classList.toggle('is-empty', parsedState.item_count === 0);
              const cartDrawerWrapper = document.querySelector('cart-drawer');
              const cartFooter = document.getElementById('main-cart-footer');

              if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
              if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

              this.getSectionsToRender().forEach((section => {
                const elementToReplace =
                  document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                elementToReplace.innerHTML =
                  this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
              }));

              //this.updateLiveRegions(line, parsedState.item_count);

              // Get line item
              // const lineItem =  document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);

              // if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
              //   cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
              // } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
              //   trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
              // } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
              //   trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
              // }
              //this.disableLoading();

              document.dispatchEvent(
                new CustomEvent("Cart-Change", {
                  bubbles: true,
                  detail: { info: "quantity updated" },
                }))

            }).catch(() => {
              this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
              const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
              errors.textContent = window.cartStrings.error;
              //this.disableLoading();
            });
        })

    }
  }

  customElements.define('cart-drawer-items', CartDrawerItems);
}

class VolumeSelector extends HTMLElement {

  constructor() {
    super()
    this.toggler = this.querySelector('.toggler')
    const volumeChoices = this.querySelector('.volume-quantity-list')
    const customVolumeSubmitButton = this.querySelector('.volume-selector-submit-button')

    this.toggler.addEventListener('click', function () {

      const drawer__inner = this.parentElement;

      switch (drawer__inner.dataset.toggle) {
        case "items": drawer__inner.dataset.toggle = "volume"; break;
        case "volume": drawer__inner.dataset.toggle = "items"; break;
      }

    }.bind(this))

    volumeChoices.addEventListener('click', this.handleChoiceChange.bind(this))
    customVolumeSubmitButton.addEventListener('click', this.handleCustomChoiceChange.bind(this))

  }

  handleChoiceChange(event) {

    const selected = event.target
    const choices = Array.from(event.target.parentElement.children)

    // Remove selected regardless
    choices.forEach(choice => choice.classList.remove('selected'))

    // Assign newly selected..
    //..in list
    selected.classList.add("selected")
    //..in header
    this.querySelector('.volume-selected').textContent = selected.dataset.volume

    // close
    this.toggler.click()

    // dispatch change
    // document.dispatchEvent(
    //   new CustomEvent("Volume-Change", {
    //     bubbles: true,
    //     detail: { info: "selected.dataset.qty" },
    //   })
    // )

    this.changeVariants(selected.dataset.volume)
  }

  handleCustomChoiceChange() {
    const input = this.querySelector('.volume-selector-input');
    const quantity = Number(input.value);

    if (quantity < 50) return;

    // close
    this.toggler.click()

    this.changeVariants(quantity)
  }

  getCartDrawerItemsElmnt() {
    return document.querySelector('cart-drawer-items')
  }

  getCartItems() {
    const cartDrawerItems = getCartDrawerItemsElmnt()
    const encodedCartItems = cartDrawerItems.dataset.items
    const jsonCartItems = decodeURIComponent(encodedCartItems)

    return jsonCartItems
  }

  getAllItemsWithVariants() {

    const cartItems = this.getCartDrawerItemsElmnt().querySelectorAll('.cart-item')

    return Array.from(cartItems).map(item => {
      const _item = {
        variants: JSON.parse(item.dataset.variants.replaceAll("'", '"')),
        quantity: item.dataset.quantity
      }
      return _item
    })

  }

  changeVariants(volume) {

    const items = this.getAllItemsWithVariants()

    // NOTE: if a product does not have a matching volume,
    // This is where an error can occur -> variantTitleKeys will be empty
    const variantTitleKeys = items.map(item => {
      return Object.keys(item.variants).filter(
        title => title.endsWith(`,${volume}`)
      )
    })

    let key = 0
    const variants = items.map(item => {
      var variant = {
        id: item.variants[variantTitleKeys[key]],
        quantity: item.quantity
      }
      key++
      return variant
    })

    document.querySelector('cart-drawer-items').swapVariants(variants)
  }

}

customElements.define('volume-selector', VolumeSelector)